import { LazyLoadImage } from "react-lazy-load-image-component";


import twitter from "../img/socials/twitter.png";
import sqtwitter from "../img/socials/sqtwitter.png";
import facebook from "../img/socials/facebook.png";
import sqfacebook from "../img/socials/sqfacebook.png";
import linkedin from "../img/socials/linkedin.png";
import sqlinkedin from "../img/socials/sqlinkedin.png";
import paypal from "../img/pp.png";
import sqpaypal from "../img/sqpp.png";

import './RFooter.css'

function RFooter(){
return <div className="footer-c">
            <div className="footer-about">
              <h3>Qodeit</h3>
              <p>
              Qodeit is a young and active company founded in 2021 to make the lives of 
PHD. Research/ Masters students easier and make Research support & 
guidance more accessible to students all over the world . We are experienced 
in providing quality research paper, research implementation support and 
thesis support specialized in computer science and many more.
              </p>
              <ul className="footer-socials">
                <li>
                  <a href="https://www.instagram.com/qodeit/" target='blank'>
                  <LazyLoadImage
              alt="twitter"
              effect="blur"
              src={twitter}
              placeholderSrc={sqtwitter}
              width="50px"
              height="50px"
            />
                  </a>
                </li>
                <li>
                  <a href=" https://www.facebook.com/profile.php?id=100076290855952" target='blank'>
                  <LazyLoadImage
              alt="facebook"
              effect="blur"
              src={facebook}
              placeholderSrc={sqfacebook}
              width="50px"
              height="50px"
            />
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/company/qodeit-research1/" target='blank'>
                  <LazyLoadImage
              alt="linkedin"
              effect="blur"
              src={linkedin}
              placeholderSrc={sqlinkedin}
              width="50px"
              height="50px"
            />
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer-r">
              <div>
                <p>About us</p>
              </div>

              <div>
                <p>Terms and Conditions</p>
              </div>

              <div>
                <p>Fair use policy</p>
              </div>
              <div>
                <p>Contact us</p>
              </div>
              <div>
                <p>Earn with us</p>
              </div>

              <div>
                <p>Blog</p>
              </div>
             
            </div>

            <div className="paypal">
                <h2>Payment patner</h2>
                <LazyLoadImage
                alt="paypal"
                effect="blur"
                src={paypal}
                placeholderSrc={sqpaypal}
                width="40px"
                height="40px"
              />
              </div>
            <p className="copyright">© Copyright 2022 Qodeit</p>

          </div>


}

export default RFooter;